import { StyledSquare } from './Square.styles'

const Square: React.FC = (): JSX.Element => {
    return <StyledSquare />
}

export default Square
